import { render } from "./TheGlobalHeader.vue?vue&type=template&id=94c546c8&scoped=true&ts=true"
import script from "./TheGlobalHeader.vue?vue&type=script&lang=ts"
export * from "./TheGlobalHeader.vue?vue&type=script&lang=ts"

import "./TheGlobalHeader.vue?vue&type=style&index=0&id=94c546c8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94c546c8"]])

export default __exports__